<template>
  <div class="room remote-history" v-loading="loading" ref="room">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="table-command">
      <div class="table-command-item">
        <span class="table-command-item-key">桥梁:</span>
        <el-select v-model="bridgeId" placeholder="请选择桥梁">
          <el-option v-for="item in bridgeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </div>
    </div>
    <el-table :data="tableData" style="width: 100%" :max-height="tableMaxHeight">
      <el-table-column align="center" label="序号" prop="index" width="80"></el-table-column>
      <el-table-column align="center" label="场景名称" prop="scenarioName" width="200"></el-table-column>
      <el-table-column align="center" label="场景分组" prop="scenarioGroup" width="200"></el-table-column>
      <el-table-column align="center" label="所属桥梁" prop="bridgeName" width="200"></el-table-column>
      <el-table-column align="center" label="窗口数量" prop="historyBlockCount" width="100"></el-table-column>
      <el-table-column align="center" label="数据数量" prop="deviceCount" width="100"></el-table-column>
      <el-table-column align="center" label="配置长度" prop="jsonLength" width="100"></el-table-column>
      <el-table-column align="center" label="创建日期" prop="createdDate" width="170"></el-table-column>
      <el-table-column align="center" label="创建用户" prop="createdUserName" width="100"></el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button size="small" type="primary" @click="moveUp(scope.row.scenarioId)" :disabled="scope.row.IsAdmin" class="table-button"
            >上移</el-button
          >
          <el-button size="small" type="primary" @click="moveTop(scope.row.scenarioId)" :disabled="scope.row.IsAdmin" class="table-button"
            >上移至顶</el-button
          >

          <el-button size="small" type="success" @click="moveDown(scope.row.scenarioId)" :disabled="scope.row.IsAdmin" class="table-button"
            >下移</el-button
          >
          <el-button size="small" type="success" @click="moveBottom(scope.row.scenarioId)" :disabled="scope.row.IsAdmin" class="table-button"
            >下移至底</el-button
          >

          <el-button
            size="small"
            type="danger"
            @click="removeScenario(scope.row.scenarioId, scope.row.scenarioName)"
            :disabled="scope.row.IsAdmin"
            class="table-button"
            >删除</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="changeName(scope.row.scenarioId, scope.row.scenarioName, scope.row.scenarioGroup)"
            :disabled="scope.row.IsAdmin"
            class="table-button"
            >修改名称</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      :style="pageStyle"
      layout="prev, pager, next"
      :total="totalCount"
      :page-size="pageSize"
      @current-change="currentChange"
      ref="page"
    ></el-pagination>
    <!-- 修改名称弹窗 -->
    <el-dialog
      width="620px"
      :visible.sync="changeNameDialogVisible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      v-loading="loading"
    >
      <div class="dialog-title" slot="title">修改场景名称</div>
      <el-form :model="changeNameFormData" :rules="changeNameFormRules" ref="changeNameForm">
        <el-form-item label="场景名称" prop="scenarioName">
          <el-input v-model="changeNameFormData.scenarioName" placeholder="请输入场景名称" class="dialog-form-input"></el-input>
        </el-form-item>
        <el-form-item label="场景分组" prop="scenarioGroup">
          <el-select v-model="changeNameFormData.scenarioGroup" filterable allow-create placeholder="请选择或输入场景分组" class="dialog-form-input">
            <el-option
              v-for="currentGroupName in historyScenarioCurrentGroupNameList"
              :key="currentGroupName"
              :label="currentGroupName"
              :value="currentGroupName"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="changeNameDialogVisible = false">取消</el-button>
        <el-button @click="submitChangeName" type="primary">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
 import { dateTimeToString, newtonsoftJsonToDate } from "../tools/GeneralTool";

export default {
  name: "RemoteHistory",
  data() {
    return {
      timer: null,
      tableData: [],
      loading: false,
      shownewUser: false,
      checkUserId: "",
      totalCount: 1,
      currentPage: 1,
      pageSize: 20,
      bridgeId: "",
      bridgeTranslateDict: {},
      deviceTranslateDict: {},
      deviceNameReplaceList: ["状态", "(枚举)"],
      tableMaxHeight: 777,
      clientHeight: 0,
      pageStyle: {},
      paginationHeight: 70,
      firstIndex: 0,
      lastIndex: 0,
      changeNameDialogVisible: false,
      changeNameFormData: {
        scenarioName: "",
        scenarioGroup: "",
        scenarioId: "",
      },
      changeNameFormRules: {
        scenarioName: [{ required: true, message: "请输入场景名称", trigger: "blur" }],
        scenarioGroup: [{ required: true, message: "请输入场景分组", trigger: "blur" }],
      },
      historyScenarioCurrentGroupNameList: [],
    };
  },
  computed: {
    tableSpanRowIndexDict() {
      let clientMissionIdRowIndexListDict = {};
      for (let i = 0; i < this.tableData.length; i++) {
        const mission = this.tableData[i];
        if (clientMissionIdRowIndexListDict[mission.clientMissionId] === undefined) {
          clientMissionIdRowIndexListDict[mission.clientMissionId] = [i];
        } else {
          clientMissionIdRowIndexListDict[mission.clientMissionId].push(i);
        }
      }

      let result = {};
      for (let clientMissionId in clientMissionIdRowIndexListDict) {
        let rowList = clientMissionIdRowIndexListDict[clientMissionId];
        result[Math.min.apply(null, rowList)] = rowList.length;
      }

      return result;
    },
    ...mapGetters({
      isAdmin: "getIsAdmin",
      bridgeList: "getBridgeList",
    }),
  },
  mounted() {
    this.loading = true;
    if (this.$route.query.bridgeId) {
      let validBridgeId = false;
      for (let bridge of this.bridgeList) {
        if (bridge.id === this.$route.query.bridgeId) {
          validBridgeId = true;
          break;
        }
      }

      if (validBridgeId) {
        this.bridgeId = this.$route.query.bridgeId;
      }
    }

    if (!this.bridgeId || this.bridgeId === "") {
      this.bridgeId = this.bridgeList[0].id;
    }

    this.getDataCount();
    this.getDataList();

    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);

    window.onresize = () => {
      this.clientHeight = document.documentElement.clientHeight;
    };
    this.tableMaxHeight = this.$refs.room.offsetHeight - this.paginationHeight;
    this.pageStyle = {
      left: (this.$refs.room.clientWidth - this.$refs.page.$el.clientWidth) / 2 + "px",
    };
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  watch: {
    clientHeight(newVal, oldVal) {
      this.tableMaxHeight = this.$refs.room.offsetHeight - this.paginationHeight;
    },
    totalCount() {
      this.$nextTick().then(() => {
        this.pageStyle = {
          left: (this.$refs.room.clientWidth - this.$refs.page.$el.clientWidth) / 2 + "px",
        };
      });
    },
    bridgeId() {
      let query = JSON.parse(JSON.stringify(this.$route.query));
      query.bridgeId = this.bridgeId;
      this.$router.replace({ query: query });

      this.refreshData();
    },
  },
  methods: {
    refreshData() {
      this.loading = true;
      this.getDataList();
    },
    currentChange(index) {
      this.loading = true;
      this.currentPage = index;
      this.getDataList();
    },
    changeName(scenarioId, scenarioName, scenarioGroup) {
      this.loading = true;

      this.changeNameFormData.scenarioName = scenarioName;
      this.changeNameFormData.scenarioGroup = scenarioGroup;
      this.changeNameFormData.scenarioId = scenarioId;
      this.historyScenarioCurrentGroupNameList = [];

      let url = "/historyScenario/GetHistoryScenarioList?bridgeId=" + this.bridgeId + "&start=0&limit=999";
      this.$http
        .get(url)
        .then((res) => {
          let scenarioList = res.data;
          for (let scenario of scenarioList) {
            let groupName = scenario.scenarioGroup;
            if (this.historyScenarioCurrentGroupNameList.indexOf(groupName) < 0) {
              this.historyScenarioCurrentGroupNameList.push(groupName);
            }
          }

          this.loading = false;
        })
        .catch((err) => {
          this.$message({
            message: "当前历史场景分组查询失败. ",
            type: "warning",
          });
          console.log(err);
          this.loading = false;
        });

      this.changeNameDialogVisible = true;
    },
    submitChangeName() {
      this.$refs.changeNameForm.validate().then(() => {
        this.loading = true;

        let body = {
          scenarioName: this.changeNameFormData.scenarioName,
          scenarioGroup: this.changeNameFormData.scenarioGroup,
          scenarioId: this.changeNameFormData.scenarioId,
        };

        this.$http
          .post("/historyScenario/UpdateHistoryScenario", body)
          .then(() => {
            this.$message({
              message: "修改历史场景成功",
              type: "success",
            });

            this.refreshData();
            this.loading = false;
            this.changeNameDialogVisible = false;
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    moveUp(scenarioId) {
      this.moveScenario(scenarioId, "MOVE_UP");
    },
    moveDown(scenarioId) {
      this.moveScenario(scenarioId, "MOVE_DOWN");
    },
    moveTop(scenarioId) {
      this.moveScenario(scenarioId, "MOVE_TO_TOP");
    },
    moveBottom(scenarioId) {
      this.moveScenario(scenarioId, "MOVE_TO_BOTTOM");
    },
    moveScenario(scenarioId, moveType) {
      this.loading = true;
      let body = {
        scenarioId: scenarioId,
        sortIndexUpdateType: moveType,
      };

      this.$http
        .post("/historyScenario/UpdateHistoryScenarioSortIndex", body)
        .then(() => {
          this.getDataList();
        })
        .catch(() => {
          this.loading = false;
        });
    },
    removeScenario(scenarioId, scenarioName) {
      this.loading = true;
      let message = "确认删除历史场景: " + scenarioName;
      this.$confirm(message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          let body = {
            scenarioId: scenarioId,
          };

          this.$http.post("/historyScenario/RemoveHistoryScenario", body).then(() => {
            this.$message({
              message: "删除历史场景成功",
              type: "success",
            });

            this.getDataList();
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getDataCount() {
      this.$http.get("/historyScenario/GetHistoryScenarioCount?bridgeId=" + this.bridgeId).then((res) => {
        this.totalCount = res.data.count;
      });
    },
    getDataList() {
      let startIndex = (this.currentPage - 1) * this.pageSize;

      this.$http
        .get("/historyScenario/GetHistoryScenarioList?bridgeId=" + this.bridgeId + "&start=" + startIndex + "&limit=" + this.pageSize)
        .then((res) => {
          let dataList = res.data;
          this.startIndex = startIndex + 1;

          for (let dataItem of dataList) {
            startIndex += 1;
            let scenarioModel = JSON.parse(dataItem.scenarioJson);

            dataItem.index = startIndex;
            dataItem.bridgeName = this.translateBridgeName(dataItem.scenarioBridgeId);
            if (scenarioModel && scenarioModel.historyBlockList) {
              dataItem.historyBlockCount = scenarioModel.historyBlockList.length;
            }
            dataItem.deviceCount = dataItem.ScenarioDeviceCount;
            dataItem.jsonLength = dataItem.ScenarioJsonLength;
            dataItem.createdDate = dateTimeToString(newtonsoftJsonToDate(dataItem.createdDate), "YY年MM月dd日 HH:mm");
          }

          this.lastIndex = startIndex;
          this.tableData = dataList;
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    translateBridgeName(bridgeId) {
      for (let bridge of this.bridgeList) {
        if (bridge.id === bridgeId) {
          return bridge.name;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.remote-history {
  margin-top: 20px;
  background-color: #fff;
  padding: 20px;
  // height: 784px !important;
  height: calc(100% - 50px) !important;
  position: relative;
  .table-command {
    display: flex;
    // justify-content: flex-end;
    margin-bottom: 20px;
  }
  .table-command-item-key {
    margin-right: 10px;
    margin-left: 20px;
  }
  .pagination {
    position: absolute;
    bottom: 0;
  }
}
.status-tag {
  cursor: pointer;
}
.table-button {
  margin-bottom: 10px;
  margin-left: 10px;
}

.dialog-form-input {
  width: 80%;
}

::v-deep .el-pagination {
  text-align: center;
}
</style>
